import script from "./office-hour-offerings-carousel.vue?vue&type=script&setup=true&lang=js"
export * from "./office-hour-offerings-carousel.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__